import React, { useContext } from 'react';
import {
  collectSource,
  contentDragSource,
  BaseDraggableSourceProps,
} from '@go-client/lib/feedEditor';
import { DragSource } from 'react-dnd';
import { CONTENT_DND_TYPE } from '@go-client/components/DraggableContentItem';
import { FeedEditorCtx } from '@go-client/context/FeedEdtitorContext';
import { generateSailingDayWidgetContentTemplate } from '@go-shared/lib/feed';
import { useServerInfo } from '@go-client/context/ServerInfoContext';

const DraggableSailingDateWidget: React.FC<BaseDraggableSourceProps> = ({
  connectDragSource,
  contentTemplate,
}) => {
  return (
    <>
      {connectDragSource(
        <div className="FeedDraggableContentItem p-2 cursor-move rounded-sm shadow border-l-8 bg-white">
          <h2 className="font-semibold uppercase">Current Date Widget</h2>
          <span className="">{contentTemplate && contentTemplate.content}</span>
          <div>
            <span className="text-grey-darkest text-xxs">Display the current date</span>
          </div>
        </div>
      )}
    </>
  );
};

export default (props: BaseDraggableSourceProps) => {
  const { property } = useContext(FeedEditorCtx);
  const serverInfo = useServerInfo();
  const { brand } = serverInfo;

  return (
    <Source
      {...props}
      contentTemplate={generateSailingDayWidgetContentTemplate(property!, brand.dateFormat)}
    />
  );
};
const Source = DragSource(
  CONTENT_DND_TYPE,
  contentDragSource<BaseDraggableSourceProps>(),
  collectSource
)(DraggableSailingDateWidget);
